/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconNotification = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps(iconProps);
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", "aria-label": "icon", ref: ref, ...props },
        React.createElement("path", { d: "M12 22c1.375 0 2.5-.923 2.5-2.051h-5C9.5 21.077 10.613 22 12 22Zm7.5-6.154v-5.128c0-3.149-2.05-5.785-5.625-6.482v-.698C13.875 2.688 13.037 2 12 2s-1.875.687-1.875 1.538v.698C6.537 4.933 4.5 7.559 4.5 10.718v5.128L2 17.897v1.026h20v-1.026l-2.5-2.05Z" })));
});
IconNotification.displayName = 'IconNotification';
export default IconNotification;
